module.exports = __webpack_public_path__ + "media/images/como_funciona/tutorial-pay-64b6914714f49dc27d22b4ed58212c5c.svg";